export const LAST_MODE_STORAGE_KEY = 'askai:chatMode';
export const POSITION_PERSIST_KEY = 'askai:chatPos';
export const PANEL_LEFT_MARGIN = 0;
export const SIDENAV_EXPANDED_WIDTH = 240;
export const SIDENAV_COLLAPSED_WIDTH = 60;
export const FULLSCREEN_MODE_KEY = 'fscr';
export const DEFAULT_ASK_AI_ELEVATION = 2000;

export const getMessageHistoryQueryKey = (threadId: string) => [
  'message-history',
  threadId,
];
